<div class="p-l-30 p-r-30 p-t-12 streams-cotainer flex flex-row">
  <particle-tree-selector
    [title]="'Stream(s)'"
    [treeData]="streamsData$"
    [quickSelections]="streamsQuickSelections$"
    [componentDisabled]="false"
    (selectionChanged)="onStreamSelectionChanged($event)">
  </particle-tree-selector>
</div>
